import { render } from "./ServiceTitle.vue?vue&type=template&id=0d07d4b6"
import script from "./ServiceTitle.vue?vue&type=script&lang=js"
export * from "./ServiceTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__